module.exports = __webpack_public_path__ + "img/add-activity.aef1b5ae.svg";